export default "__VITE_ASSET__B$jVzBrg__"